// src/hooks/useVehicleModels.js

import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from 'BaseURL';

const useVehicleModels = () => {
  const [vehicleModels, setVehicleModels] = useState([]);

  useEffect(() => {
    const fetchVehicleModels = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}shiftlens_warehouse/api/vehicle-models/`
        );
        setVehicleModels(response.data);
    } catch {
      }
    };

    fetchVehicleModels();
  }, []);

  return vehicleModels;
};

export default useVehicleModels;
